const initialState = {
  assignmentRulesSummary: null,
  generalRules: [],
  thirdRuleBackup: {},
  assignmentRules: [],
  incompleteAssignmentRules: [],
  incompleteAssignmentRulesIds: [],
  activeAssignmentRulesCount: 0,
  activeGeneralRulesCount: 0,
  assignmentRulesShowInactive: false,
  assignmentRulesOptions: {
    general_rules: {},
    incomplete_rules: [
      'sales_incomplete_rule',
      'rental_incomplete_rule',
      'weekend_guard_incomplete_rule',
    ],
  },
  developmentRules: [],
  upgradePending: false,

  assignmentLimits: {
    daily_inquiry_limit: { enabled: false, value: null, ignored_rule_ids: [] },
    validity: {
      enabled: false,
      value: null,
      unit: 'days',
      ignored_rule_ids: [],
    },
  },
  loadingGetAssignmentLimits: true,
  errorGetAssignmentLimits: false,
  loadingUpdateAssignmentLimits: false,
  updateAssignmentLimitsOrder: [],
  appliedUpdateAssignmentLimitsOrder: -1,
  errorUpdateAssignmentLimits: false,

  // Edit rule state
  editingRuleData: null,
  loadingGetAssignmentRule: false,
  errorGetAssignmentRule: false,

  // Origins data
  origins: [],
  hasCombinedOperationPortal: false,
  loadingGetOrigins: false,
  errorGetOrigins: false,

  // Lead Statuses data
  leadStatuses: [],
  loadingGetLeadStatuses: false,
  errorGetLeadStatuses: false,

  // Branches data
  branches: [],
  loadingGetBranches: false,
  errorGetBranches: false,

  // Teams data
  teams: [],
  loadingGetTeams: false,
  errorGetTeams: false,

  // Custom Tags data
  customTags: [],
  customTagsGroupMap: {},
  loadingGetCustomTags: false,
  errorGetCustomTags: false,

  // Loading and error states
  loadingCreateAssignmentRule: false,
  errorCreateAssignmentRule: false,

  // Assignment Rule Form State
  assignmentRuleForm: {
    ruleName: '',
    isEditing: true,
    currentStep: 1, // FORM_STEPS.NAME
    isActive: true,
    isValid: false,
    errorMessage: '',
    hasValidationErrors: false,

    // Section visibility flags
    showNameInput: true,
    showCriteriaSection: false,
    showActionsSection: false,

    // Related publication criteria
    selectedPropertyTypes: [],
    selectedCharacteristic: null,
    selectedOperationType: null,
    selectedAttributes: [],
    selectedPrice: null,
    selectedLocations: [],
    selectedTags: [],
    criteriaOrder: [],

    // Criteria section visibility flags
    showAddCriterionButton: true,
    showCharacteristicsList: false,
    showPropertyTypeCriteria: false,
    showOperationTypeCriteria: false,
    showAttributesCriteria: false,
    showPriceCriteria: false,
    showLocationCriteria: false,
    showTagsCriteria: false,

    // Additional state for criteria management
    attributeValues: {},
    attributeValidationErrors: {},

    // New assignment-specific characteristics
    selectedProperties: [],
    showPropertiesCriteria: false,
    selectedOrigins: [],
    showOriginCriteria: false,
    selectedBranches: [],
    showBranchCriteria: false,
    selectedInquiryTags: [],
    showInquiryTagsCriteria: false,
    selectedLeadStatus: [],
    showLeadStatusCriteria: false,
    selectedAgentsInCharge: [],
    showAgentsInChargeCriteria: false,

    selectedActions: {},

    /** UI-only backup when toggling RR clears chances in selectedActions (per contact_status). */
    distributionChancesDraft: {
      existing_contact: null,
      new_contact: null,
    },

    // optionals section
    schedules: {
      ruleSchedule: 0, // 0=everyday (default), 1=weekdays, 2=weekend, 3=custom
      scheduleTimeIntervals: null,
    },
    selectedContactTags: [],

    // Out-of-office specific state:
    // fallbackOption: 'reassign' | 'keep_same' — strategy when returning to working hours
    // fallbackAgentIds: agent ids used when 'reassign' finds no matching active rule
    fallbackOption: 'reassign',
    fallbackAgentIds: [],
  },
  agents: [],
  loadingGetAgents: false,
  errorGetAgents: false,
};

export default initialState;
